module.exports = __webpack_public_path__ + "static/img/software.6d2ae6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/software.png
// module id = 4nAt
// module chunks = 0